module.exports = require("./dyo.d.ts");